/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import makeStyles from '@mui/styles/makeStyles';

export const useNavigationHeaderStyles = makeStyles({
  root: {
    padding: '10px',
    backgroundColor: '#FFFF',
    display: 'flex',
    justifyContent: 'center',
  },
  imageLogo: {
    width: 'auto',
    height: '80px',
    maxWidth: '143px',
    maxHeight: '100%',
  },
});
